import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { EMAIL_APP_STORE } from '@v2/modules/email-app/email-app.store';
import { Observable } from 'rxjs';

export const emailAuthenticatedGuardFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(EmailAuthenticatedGuard).canActivate(route, state);
};

@Injectable({
  providedIn: 'root',
})
export class EmailAuthenticatedGuard {
  private _emailStore = inject(EMAIL_APP_STORE);
  private _router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this._emailStore.isAuthenticated()) {
      return true;
    }

    this._router.navigate(['/']);
    return false;
  }
}
